export default {
  setUserPermissions(permissions) {
    this.userPermissions = permissions
  },
  setExternalBIMenus(menus) {
    this.externalBIMenus = menus
  },
}
